import React, {createContext, useContext, useState, useMemo} from 'react';

interface VersionContextValue {
    versionMismatch: boolean;
    setVersionMismatch: React.Dispatch<React.SetStateAction<boolean>>;
    clientVersion: string;
}

const VersionContext = createContext<VersionContextValue | undefined>(
    undefined
);

export const VersionProvider: React.FC<{children: React.ReactNode}> = ({
    children
}) => {
    const injectedVersion =
        document
            .querySelector('meta[name="app-version"]')
            ?.getAttribute('content') || '';

    const [versionMismatch, setVersionMismatch] = useState(false);

    const value = useMemo(() => {
        return {
            versionMismatch,
            setVersionMismatch,
            clientVersion: injectedVersion
        };
    }, [versionMismatch, injectedVersion]);

    return (
        <VersionContext.Provider value={value}>
            {children}
        </VersionContext.Provider>
    );
};

export function useVersionContext(): VersionContextValue {
    const ctx = useContext(VersionContext);
    if (!ctx) {
        throw new Error(
            'useVersionContext must be used within a VersionProvider'
        );
    }

    return ctx;
}
